import { Box, VStack, useBreakpointValue } from '@chakra-ui/react';
import {
  SWAP_DEMO_CHECKED_INDICES,
  SWAP_DEMO_COUNTRY_LIST,
} from '@/constants/swapDemoCountryList';
import { SwapTeamRow } from './SwapTeamRow';

const checkedSet = new Set<number>(SWAP_DEMO_CHECKED_INDICES);

/** Read-only swap UI preview for the announcement modal. */
export function SwapTeamIllustration() {
  const compact = useBreakpointValue({ base: true, md: false }) ?? true;
  const rankFontSize = useBreakpointValue({ base: 14, md: 18 }) ?? 14;
  const rowSpacing = useBreakpointValue({ base: 1, md: 1.5 }) ?? 1;

  return (
    <Box
      aria-hidden
      role='presentation'
      w='full'
      maxW={{ base: '100%', sm: '340px', md: '400px' }}
      mx='auto'
      pointerEvents='none'
      color='chakra-body-text'
    >
      <VStack spacing={rowSpacing} align='stretch'>
        {SWAP_DEMO_COUNTRY_LIST.map((country, index) => (
          <SwapTeamRow
            key={country}
            rank={index + 1}
            index={index}
            country={country}
            compact={compact}
            rankFontSize={rankFontSize}
            spacing={rowSpacing}
            minH={{ base: '2.25rem', md: '2.5rem' }}
            illustrative
            illustrativeChecked={checkedSet.has(index)}
          />
        ))}
      </VStack>
    </Box>
  );
}
